export default (theme) => ({
    root: {
        width: '100%',
        height: '100%',
        borderRadius: '8px',
        overflow: 'hidden',
    },
});
